import fetch from './';
import { saveAs } from 'file-saver';
import { sanitizeFilename } from '../utils/fileExports';

export type AdhocReportBenchmarkSet = {
	benchmarkSetName: string;
	filePath: string;
	benchmarkSetType: string;
	regionAbbreviation: string;
};

export type AdhocReportGradepoint = {
	key: string;
};

export type AdhocReportDataItem = {
	datasetId: string;
	providerName: string;
};

export type AdhocReportDocument = {
	fileType: 'Pdf' | string;
	name: string;
	examLevels: string;
	blobStorageKey: string;
	academicYear?: number;
};

export type AdhocReportRequestBody = {
	benchmarkSet: AdhocReportBenchmarkSet;
	gradepoints: AdhocReportGradepoint[];
	dataItems: AdhocReportDataItem[];
	clientName: string;
	documents: AdhocReportDocument[];
	academicYear: number;
};

const genericAdhocReportUri = '/alpine-docs/v1/Adhoc/AdhocReport/GenerateReport';
const genericCapped9ReportUri = '/alpine-docs/v1/Adhoc/AdhocReport/GetCapped9Report';

export const fetchAdhocReportPDF = (
	payload: AdhocReportRequestBody,
	filename: string = 'AdhocReport',
	options: { abortId?: string; url?: string } = {}
) => {
	const endpoint = options.url ?? genericAdhocReportUri;

	return fetch(endpoint, {
		abortId: options.abortId ?? 'AdhocReport_PDF',
		responseType: 'blob',
		body: payload,
		headers: {
			Accept: 'application/pdf',
			'Content-Type': 'application/json',
		},
	}).then((blob: any) => {
		saveAs(blob, sanitizeFilename(filename, 'pdf'));
	});
};

export const fetchCapped9ReportExcel = (
	filename: string = 'Capped9Report',
	options: { abortId?: string; url?: string } = {}
) => {
	const endpoint = options.url ?? genericCapped9ReportUri;

	return fetch(endpoint, {
		abortId: options.abortId ?? 'Capped9Report_Excel',
		responseType: 'blob',
		headers: {
			Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		},
	}).then((blob: any) => {
		saveAs(blob, sanitizeFilename(filename, 'xlsx'));
	});
};
